module.exports = __webpack_public_path__ + "static/media/logo.eb0d3a11.png";